import context, { IAppUserContext } from '@truckdown/components-systems';
import { IInitializer, IUserContext } from "@truckdown/systems";
import { defineAsyncComponent } from 'vue';
import addressValidator from './AddressValidator.vue';
import createOrSignin from './CreateOrSignin.vue';
import accountHeader from './Admin/AccountHeader/AccountHeader.vue';
import adminSubNav from './Admin/AdminSideNav/AdminSideNav.vue';

class AccountsComponentInitializer implements IInitializer {
    name: string = 'AccountsComponentInitializer';
    order: number = 0;


    async initialize(context: IUserContext): Promise<void> {
        let app = (context as IAppUserContext).app;

        app.component('AddressValidator', addressValidator);
        app.component('CreateOrSignin', createOrSignin);
        app.component('account-header', accountHeader);
        app.component('admin-side-nav', adminSubNav);

        app.component('account-summary',
            defineAsyncComponent(() => import(/* webpackChunkName: "account-summary" */ './Admin/AccountSummary/AccountSummary.vue')));

        app.component('invite-user',
            defineAsyncComponent(() => import(/* webpackChunkName: "invite-user" */ './Admin/InviteUser/InviteUser.vue')));

        app.component('verify-account',
            defineAsyncComponent(() => import(/* webpackChunkName: "verify-account" */ './Admin/VerifyAccount/VerifyAccount.vue')));

        app.component('account-comments',
            defineAsyncComponent(() => import(/* webpackChunkName: "account-comments" */ './Admin/AccountComments/AccountComments.vue')));
    }
}

context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return new AccountsComponentInitializer();
    }
});
